import { getApiInstance } from '../../../helpers/api.helpers';
const normalizeSendResult = (body) => {
    const d = (body && typeof body === 'object' && 'data' in body ? body.data : body);
    if (d?.status === 'sent') {
        return { status: 'sent' };
    }
    if (d?.status === 'scheduled' && typeof d.sendAt === 'string') {
        return { status: 'scheduled', sendAt: d.sendAt };
    }
    return null;
};
/**
 * Sends or schedules a study notification template to a participant
 * (`POST /v2/routes/c_sites/:siteId/c_public_users/:publicUserId/c_notifications`, AXONCONFIG-5254).
 */
export const sendParticipantNotification = async ({ environment, siteId, participantId, notificationName, offsetMinutes, locale, }) => {
    const api = getApiInstance(environment, locale);
    const resp = await api.post(`/v2/routes/c_sites/${siteId}/c_public_users/${participantId}/c_notifications`, {
        notificationName,
        offsetMinutes,
    });
    const result = normalizeSendResult(resp.data);
    if (!result) {
        throw new Error('Unexpected send notification response');
    }
    return result;
};
